/* MT/26 — info/blog pages: TOC from h2, active state, FAQ search, copy link, chat opener */
(function () {
  'use strict';
  function q(s, sc) { return (sc || document).querySelector(s); }
  function qa(s, sc) { return Array.prototype.slice.call((sc || document).querySelectorAll(s)); }
  function slug(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }
  function buildToc(root) {
    var content = q('[data-mt-content]', root), toc = q('[data-mt-toc]', root), list = q('[data-mt-toc-list]', root), mob = q('[data-mt-toc-mobile]', root);
    if (!content || !toc || toc.dataset.built) return;
    var hs = qa('h2', content).filter(function (h) { return h.textContent.trim().length > 1; }); if (hs.length < 2) return;
    toc.dataset.built = '1';
    hs.forEach(function (h, i) { if (!h.id) h.id = slug(h.textContent) || ('section-' + (i + 1)); });
    list.innerHTML = hs.map(function (h) { return '<a href="#' + h.id + '" data-mt-toc-link>' + h.textContent + '</a>'; }).join('');
    toc.hidden = false;
    var lay = q('[data-mt-info-layout]', root); if (lay) lay.classList.add('mt-info__layout--toc');
    if (mob) { mob.innerHTML = hs.map(function (h) { return '<a class="mt-chip" href="#' + h.id + '">' + h.textContent + '</a>'; }).join(''); mob.hidden = false; }
    if ('IntersectionObserver' in window) {
      var links = qa('[data-mt-toc-link]', list);
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('mt-on', l.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-10% 0px -70% 0px' });
      hs.forEach(function (h) { io.observe(h); });
      if (links[0]) links[0].classList.add('mt-on');
    }
  }
  function initFaq(root) {
    if (root.dataset.mtReady) return; root.dataset.mtReady = '1';
    var s = q('[data-mt-faqc-search]', root);
    if (s) s.addEventListener('input', function () {
      var v = s.value.trim().toLowerCase(), any = false;
      qa('[data-mt-faqc-item]', root).forEach(function (d) { var hit = !v || d.textContent.toLowerCase().indexOf(v) > -1; d.hidden = !hit; if (hit) any = true; if (v && hit) d.open = true; });
      qa('.mt-faqc__group', root).forEach(function (g) { g.hidden = !qa('[data-mt-faqc-item]:not([hidden])', g).length; });
      var e = q('[data-mt-faqc-empty]', root); if (e) e.hidden = any;
    });
    var cats = qa('[data-mt-faqc-cat]', root); if (cats[0]) cats[0].classList.add('mt-on');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) cats.forEach(function (c) { c.classList.toggle('mt-on', c.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-10% 0px -70% 0px' });
      qa('.mt-faqc__group[id]', root).forEach(function (g) { io.observe(g); });
    }
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-mt-copy]');
    if (c && navigator.clipboard) { navigator.clipboard.writeText(c.dataset.mtCopy); var t = c.textContent; c.textContent = '✓'; setTimeout(function () { c.textContent = t; }, 1200); }
    var ch = e.target.closest('[data-mt-open-chat]');
    if (ch) {
      if (window.tidioChatApi) tidioChatApi.open();
      else if (window.GorgiasChat) GorgiasChat.open();
      else if (window.$crisp) $crisp.push(['do', 'chat:open']);
      else if (window.Intercom) Intercom('show');
      else document.dispatchEvent(new CustomEvent('mt:open-chat'));
    }
  });
  function boot() { qa('[data-mt-info], [data-mt-article]').forEach(buildToc); qa('[data-mt-faqc]').forEach(initFaq); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
